/** Base path for the sms_manager API on the platform host. */
export var SMS_API_BASE = "/api/sms";

/** Absolute endpoint paths for the coordinator SMS flow. */
export var SMS_ENDPOINTS = {
  messages: "".concat(SMS_API_BASE, "/messages/"),
  retry: function retry(id) {
    return "".concat(SMS_API_BASE, "/messages/").concat(id, "/retry/");
  },
  patientMessages: function patientMessages(patientId) {
    return "".concat(SMS_API_BASE, "/patients/").concat(patientId, "/messages/");
  },
  optOutStatus: function optOutStatus(patientId) {
    return "".concat(SMS_API_BASE, "/patients/").concat(patientId, "/opt-out-status/");
  },
  templates: "".concat(SMS_API_BASE, "/templates/"),
  template: function template(id) {
    return "".concat(SMS_API_BASE, "/templates/").concat(id, "/");
  }
};

/** React Query cache key prefix for a patient's SMS message list. */
export var SMS_PATIENT_MESSAGES_KEY = "sms-patient-messages";

/** React Query cache keys for the SMS queries. */
export var SMS_QUERY_KEYS = {
  patientMessages: function patientMessages(patientId) {
    return [SMS_PATIENT_MESSAGES_KEY, patientId];
  },
  optOutStatus: function optOutStatus(patientId) {
    return ["sms-opt-out-status", patientId];
  },
  templates: function templates(workspaceId) {
    return ["sms-templates", workspaceId];
  }
};